import { Breadcrumbs } from "@/components/Breadcrumbs";
import { AdminSidebar } from "@/components/admin/AdminSidebar";
import { useAuthStore } from "@/lib/auth";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin")({
	beforeLoad: () => {
		const { user, isAuthenticated } = useAuthStore.getState();
		if (!isAuthenticated) {
			throw redirect({ to: "/login" });
		}
		if (!user?.isSuperAdmin) {
			throw redirect({ to: "/catalog/products", search: { owner_party_id: undefined } });
		}
	},
	component: AdminLayout,
});

function AdminLayout() {
	return (
		<div className="flex h-screen overflow-hidden">
			<AdminSidebar />
			<main className="flex-1 overflow-y-auto">
				<div className="border-b px-6 py-2.5 bg-background sticky top-0 z-10">
					<Breadcrumbs />
				</div>
				<div className="px-6 pt-4 pb-6">
					<Outlet />
				</div>
			</main>
		</div>
	);
}
